<template>
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    enable-background="new 0 0 24 24"
    height="24px"
    version="1.1"
    viewBox="0 0 24 24"
    width="24px"
    xml:space="preserve"
  >
    <g>
      <path
        d="M20.9,0H1.1C0.5,0,0,0.5,0,1.1v21.8C0,23.5,0.5,24,1.1,24h19.8c0.6,0,1.1-0.5,1.1-1.1V1.1C22,0.5,21.5,0,20.9,0z M20,22H2   V2h18V22z"
      />
      <g>
        <rect height="1" width="12" x="5" y="8" />
        <rect height="1" width="12" x="5" y="6" />
        <rect height="1" width="12" x="5" y="10" />
        <rect height="1" width="12" x="5" y="12" />
        <rect height="1" width="12" x="5" y="14" />
        <rect height="1" width="12" x="5" y="16" />
        <rect height="1" width="12" x="5" y="18" />
      </g>
    </g>
  </svg>
</template>
